export const WEARS = [
  { value: 0, label: 'Niveau 0 (aucune)' },
  { value: 1, label: 'Niveau 1 (normale)' },
  { value: 2, label: 'Niveau 2 (légère)' },
  { value: 3, label: 'Niveau 3 (sévère)' },
]

export const WEAR_ICONS = {
  0: { type: 'is-green', icon: 'heart-circle-check' },
  1: { type: 'is-yellow', icon: 'heart-circle-exclamation' },
  2: { type: 'is-orange', icon: 'heart-circle-exclamation' },
  3: { type: 'is-red', icon: 'heart-circle-xmark' },
}
